import { useQuery } from '@tanstack/react-query';
import { getOfferingOptions } from '../../lib/api/options';
import type { GetOfferingOptionsParams } from '../../lib/api/options';

export function useOfferingOptions(params: GetOfferingOptionsParams = {}, enabled = true) {
  return useQuery({
    queryKey: ['options', 'offerings', JSON.stringify(params)],
    queryFn: () => getOfferingOptions(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
